"use client"
import { useState, useEffect } from "react"
import "./FeatureSection.css"
import ProductIdeationCard from "../components/ProductIdeationCard"
import BlueSectionDivider from "./BlueSectionDivider"

const ideationCards = [
  {
    title: "Scoping Session",
    desc: "Build a solid roadmap to make your vision real and plan ahead for your product development.",
    route: "/services/scoping-session",
  },
  {
    title: "Product Design Process",
    desc: "A collection of matured techniques to build meaningful and user-driven interfaces.",
    route: "/services/product-design",
  },
  {
    title: "Digital Transformation",
    desc: "A seamless transformation approach with a smooth transition to the digital realm.",
    route: "/services/digital-transformation",
  },
  {
    title: "Minimum Viable Product",
    desc: "Identify the core functionalities of your business idea and build an MVP to validate it.",
    route: "/services/minimum-viable",
  },
]

const productDevelopment = [
  {
    title: "Software Development",
    desc: "Build high-quality and technical debt-free software following the Agile Development Process.",
    route: "/services/software-development",
  },
  {
    title: "Web Development",
    desc: "Build user-centric websites, web solutions, and custom web applications and scale your online presence.",
    route: "/services/web-development",
  },
  {
    title: "MOBILE DEVELOPMENT",
    desc: "Build a strong brand with mobile apps adjusted to your market needs and user experience.",
    route: "/services/mobile-development",
  },
  {
    title: "NEARSHORE TEAMS",
    desc: "A hassle-free project setup, with teams that help you hit the ground confidently and efficiently.",
    route: "/services/nearshore-teams",
  },
  {
    title: "DATA SCIENCE",
    desc: "Architect, build, and scale custom Data Science solutions for your business.",
    route: "/services/ai-ds",
  },
  {
    title: "UX/UI DESIGN",
    desc: "Design your product from top to bottom and skyrocket its usability, efficiency, and users' needs.",
    route: "/services/ui-ux",
  },
  {
    title: "QUALITY ASSURANCE",
    desc: "Ensure an error-free software development by focusing on prevention rather than just detection.",
    route: "/services/qa",
  },
]

const productImprovement = [
  {
    title: "DIGITAL ACCELERATION",
    desc: "Helping you swiftly embrace digital acceleration and achieve remarkable growth.",
    route: "/services/digital-acceleration",
  },
  {
    title: "CODE AUDIT",
    desc: "Our code review process ensures a fine-tuned product from its very core.",
    route: "/services/code-audit",
  },
  {
    title: "UX AUDIT",
    desc: "We conduct a UX Audit to identify issues and provide detailed recommendations to optimize it.",
    route: "/services/ux-audit",
  },
]

const FeatureSection = () => {
  const [active, setActive] = useState("services")
  const [isMobile, setIsMobile] = useState(false)
  const internalSectionIds = ["services", "case-studies", "why-us", "tech-stack", "contact-us"]

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const navbarHeight = 80
      const scrollPosition = window.scrollY + navbarHeight

      for (let i = internalSectionIds.length - 1; i >= 0; i--) {
        const section = document.getElementById(internalSectionIds[i])
        if (section && section.offsetTop <= scrollPosition) {
          setActive(internalSectionIds[i])
          break
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    handleScroll()
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleClick = (id) => {
    setActive(id)
    const section = document.getElementById(id)
    if (section) {
      const yOffset = -80
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: "smooth" })
    }
  }

  return (
    <>
      <div className={`feature-navbar ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          <ul>
            {internalSectionIds.map((item) => (
              <li key={item}>
                <a 
                  onClick={() => handleClick(item)} 
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase().replace(/-/g, " ")}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <section className="feature-section" id="services">
        <div className="container">
          <div className="feature-content">
            <p>
              We offer custom development that follows fast, reliable, and technical debt-free processes to ensure
              companies can scale without technology getting in the way.
              <br />
              <b>‍That is what we call seamless technology.</b>
            </p>
          </div>
          <div className="feature-card-wrapper">
            <ProductIdeationCard title="PRODUCT IDEATION" cards={ideationCards} isMobile={isMobile} />
            <ProductIdeationCard title="PRODUCT DEVELOPMENT" cards={productDevelopment} isMobile={isMobile} />
            <ProductIdeationCard title="PRODUCT IMPROVEMENT" cards={productImprovement} isMobile={isMobile} />
          </div>
        </div>
      </section>

      <BlueSectionDivider />
    </>
  )
}

export default FeatureSection